import React, { Fragment } from 'react'

import ProfileIcon from 'custom/assets/common-icons/Profile.svg'
import ChangePasswordIcon from 'custom/assets/common-icons/Change_Password.svg'
import NotificationIcon from 'custom/assets/common-icons/Notification_Icon.svg'
import Dashboard_DepositIcon from 'custom/assets/dashboard/deposit.svg'
import Dashboard_DownloadCenterIcon from 'custom/assets/dashboard/Download_center.svg'
import Dashboard_LoansIcon from 'custom/assets/dashboard/loan.svg'
import Dashboard_PaymentsIcon from 'custom/assets/dashboard/payments.svg'
import Dashboard_SupportCenterIcon from 'custom/assets/dashboard/Support_Center.svg'
import Dashboard_TransfersIcon from 'custom/assets/dashboard/transfers.svg'
import Dashboard_PortfolioIcon from 'custom/assets/dashboard/portfolio.svg'
import Dashboard_AccountsIcon from 'custom/assets/dashboard/Accounts.svg'
import Dashboard_RequestIcon from 'custom/assets/dashboard/Request.svg'
import Dashboard_ExchangeIcon from 'custom/assets/quick-links/exchange.svg'
import Dashboard_OtherServicesIcon from 'custom/assets/dashboard/OtherServices.svg'
import { MENU_NAMES_ICONS_KEYS, ACCOUNTS_MENU_KEYS } from '../../utils/translation-constants'

export const MENU_DETAILS = [
  {
    title: MENU_NAMES_ICONS_KEYS.STATEMENT,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_AccountsIcon,
    parentIcon: Dashboard_AccountsIcon,
    breadCumKey: 'STATEMENTS',
    link: '/statement',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.ACCOUNT,
        link: '/accounts',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.PROFILE_SETTING,
    desc: MENU_NAMES_ICONS_KEYS.PROFILE_DESC,
    icon: ProfileIcon,
    parentIcon: ProfileIcon,
    breadCumKey: 'PROFILE',
    link: '/profile',
    parent: [],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.CHANGE_PASSWORD,
    desc: MENU_NAMES_ICONS_KEYS.CHANGE_PASSWORD_DESC,
    icon: ChangePasswordIcon,
    parentIcon: ChangePasswordIcon,
    breadCumKey: 'CHANGE_PASSWORD',
    link: '/change-password',
    parent: [],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.NOTIFICATION,
    desc: MENU_NAMES_ICONS_KEYS.NOTIFY_DESC,
    icon: NotificationIcon,
    parentIcon: NotificationIcon,
    breadCumKey: 'NOTIFICATION',
    link: '/notifications',
    parent: [],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.ACCOUNT,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_AccountsIcon,
    parentIcon: Dashboard_AccountsIcon,
    breadCumKey: 'ACCOUNTS',
    link: '/accounts',
    parent: [],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.DOWNLOAD_CENTER,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_OtherServicesIcon,
    parentIcon: Dashboard_OtherServicesIcon,
    breadCumKey: 'DOWNLOAD_CENTER',
    link: '/download-center',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.OTHER_SERVICES,
        link: '/additional-links',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.RECEIPTS,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_OtherServicesIcon,
    parentIcon: Dashboard_OtherServicesIcon,
    breadCumKey: 'RECEIPTS',
    link: '/receipts',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.OTHER_SERVICES,
        link: '/additional-links',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.DOWNLOAD_CENTER,
        link: '/download-center',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.DOWNLOAD_CENTER,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_DownloadCenterIcon,
    parentIcon: Dashboard_DownloadCenterIcon,
    breadCumKey: 'TRANSFERS_RECEIPTS',
    link: '/transfers/download-center',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.TRANSFERS,
        link: '/transfers',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.BANK_STATEMENT,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_OtherServicesIcon,
    parentIcon: Dashboard_OtherServicesIcon,
    breadCumKey: 'BI',
    link: '/biStatement',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.OTHER_SERVICES,
        link: '/additional-links',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.DOWNLOAD_CENTER,
        link: '/download-center',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.MT103,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_OtherServicesIcon,
    parentIcon: Dashboard_OtherServicesIcon,
    breadCumKey: 'MT103',
    link: '/mt103',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.OTHER_SERVICES,
        link: '/additional-links',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.DOWNLOAD_CENTER,
        link: '/download-center',
      },
    ],
  },
  {
    title: MENU_NAMES_ICONS_KEYS.SALARY_FILE,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_OtherServicesIcon,
    parentIcon: Dashboard_OtherServicesIcon,
    breadCumKey: 'SALARY_STATUS_DOWNLOAD',
    link: '/salary-file-status-download',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.OTHER_SERVICES,
        link: '/additional-links',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.DOWNLOAD_CENTER,
        link: '/download-center',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.SUPPORT_CENTER,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_OtherServicesIcon,
    parentIcon: Dashboard_OtherServicesIcon,
    breadCumKey: 'SUPPORT_CENTER',
    link: '/support-center',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.OTHER_SERVICES,
        link: '/additional-links',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.FAQ,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_OtherServicesIcon,
    parentIcon: Dashboard_OtherServicesIcon,
    breadCumKey: 'FAQ',
    link: '/faq',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.OTHER_SERVICES,
        link: '/additional-links',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.SUPPORT_CENTER,
        link: '/support-center',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.SUGGESTIONS,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_OtherServicesIcon,
    parentIcon: Dashboard_OtherServicesIcon,
    breadCumKey: 'SUGGESTION',
    link: '/suggestion',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.OTHER_SERVICES,
        link: '/additional-links',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.SUPPORT_CENTER,
        link: '/support-center',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.LOCATE_US,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_OtherServicesIcon,
    parentIcon: Dashboard_OtherServicesIcon,
    breadCumKey: 'LOCATE_US',
    link: '/locateUs',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.OTHER_SERVICES,
        link: '/additional-links',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.SUPPORT_CENTER,
        link: '/support-center',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.CONTACT_US,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_OtherServicesIcon,
    parentIcon: Dashboard_OtherServicesIcon,
    breadCumKey: 'CONTACT_US',
    link: '/contact-us',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.OTHER_SERVICES,
        link: '/additional-links',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.SUPPORT_CENTER,
        link: '/support-center',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.ABOUT_US,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_OtherServicesIcon,
    parentIcon: Dashboard_OtherServicesIcon,
    breadCumKey: 'ABOUT_US',
    link: '/about-us',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.OTHER_SERVICES,
        link: '/additional-links',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.SUPPORT_CENTER,
        link: '/support-center',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.OTHER_SERVICES,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_OtherServicesIcon,
    parentIcon: Dashboard_OtherServicesIcon,
    breadCumKey: 'ADDITIONAL_LINKS',
    link: '/additional-links',
    parent: [],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.CALCULATOR,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_OtherServicesIcon,
    parentIcon: Dashboard_OtherServicesIcon,
    breadCumKey: 'CALCULATOR',
    link: '/calculator',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.OTHER_SERVICES,
        link: '/additional-links',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.TERMS_CONDITIONS,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_OtherServicesIcon,
    parentIcon: Dashboard_OtherServicesIcon,
    breadCumKey: 'TERMS AND CONDITIONS',
    link: '/tc',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.OTHER_SERVICES,
        link: '/additional-links',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.EXCHANGE_RATE,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_ExchangeIcon,
    parentIcon: Dashboard_ExchangeIcon,
    breadCumKey: 'EXCHANGE_RATES',
    link: '/exchange-rate',
    parent: [],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.PORTFOLIO,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PortfolioIcon,
    parentIcon: Dashboard_PortfolioIcon,
    breadCumKey: 'PORTFOLIO',
    link: '/portfolio',
    parent: [],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.LOANS,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_LoansIcon,
    parentIcon: Dashboard_LoansIcon,
    breadCumKey: 'LOANS',
    link: '/loans',
    parent: [],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.APPLY_LOAN,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_LoansIcon,
    parentIcon: Dashboard_LoansIcon,
    breadCumKey: 'APPLY_LOAN',
    link: '/loans/apply',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.LOANS,
        link: '/loans',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.MAKE_LOAN_PAYMENT,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_LoansIcon,
    parentIcon: Dashboard_LoansIcon,
    breadCumKey: 'LOAN_PAYMENT',
    link: '/loans/repayment',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.LOANS,
        link: '/loans',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.DEPOSIT,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_DepositIcon,
    parentIcon: Dashboard_DepositIcon,
    breadCumKey: 'DEPOSIT',
    link: '/deposit-view',
    parent: [],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.TERM_DEPOSIT,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_DepositIcon,
    parentIcon: Dashboard_DepositIcon,
    breadCumKey: 'TERM_DEPOSIT',
    link: '/create-term-deposits',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.DEPOSIT,
        link: '/deposit-view',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.PAYMENT,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'PAYMENTS',
    link: '/payments',
    parent: [],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.SERVICES,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'PRODUCTS',
    link: '/payments/products/list',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.PAYMENT,
        link: '/payments',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.SERVICES,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'BILLER_SERVICES_VIEW',
    link: '/payments/servicesView',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.PAYMENT,
        link: '/payments',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.PAY_BILLS,
        link: '/payments/payBills',
      },

    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.FORM,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'BILLER_SERVICE_FORM',
    link: '/payments/services/product',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.PAYMENT,
        link: '/payments',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.PAY_BILLS,
        link: '/payments/PayBills',
      }
    ],
  },
  

  {
    title: MENU_NAMES_ICONS_KEYS.VIEW_BILLER,
    desc: MENU_NAMES_ICONS_KEYS.VIEW_BILLER_DESC,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'VIEW_BILLER',
    link: '/payments/biller-list',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.PAYMENT,
        link: '/payments',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.PAY_BILLS,
    desc: MENU_NAMES_ICONS_KEYS.PAY_BILLS_DESC,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'PAY_BILLS',
    link: '/payments/payBills',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.PAYMENT,
        link: '/payments',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.ADD_BILLER,
    desc: MENU_NAMES_ICONS_KEYS.ADD_BILLER_DESC,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'ADD_BILLER',
    link: '/payments/add-biller',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.PAYMENT,
        link: '/payments',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.VIEW_SCHEDULED_PAYMENTS,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_DownloadCenterIcon,
    parentIcon: Dashboard_DownloadCenterIcon,
    breadCumKey: 'SCHEDULED_PAYMENTS',
    link: '/payments/viewScheduled',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.PAYMENT,
        link: '/payments',
      }
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.TRANSFERS,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'TRANSFERS',
    link: '/transfers',
    parent: [],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.BULK_TRANSFER,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'BULK_TRANSFER',
    link: '/transfers/bulkTransfer',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.TRANSFERS,
        link: '/transfers',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.SALARY_UPLOAD,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'SALARY_UPLOAD',
    link: '/transfers/salaryUpload',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.TRANSFERS,
        link: '/transfers',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.ADD_BENEFICIARY,
    desc: MENU_NAMES_ICONS_KEYS.ADD_BENE_DESC,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'ADD_BENE',
    link: '/transfers/add-beneficiary',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.TRANSFERS,
        link: '/transfers',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.DOWNLOAD_CENTER,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'DOWNLOAD_BENE',
    link: '/transfers/download-center',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.TRANSFERS,
        link: '/transfers',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.SERVICES,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'TRANSFERS_BILLER_SERVICES_VIEW',
    link: '/transfers/quick-pay/servicesView',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.TRANSFERS,
        link: '/transfers',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.QUICKY_PAY,
        link: '/transfers/quick-pay',
      },
    ],
  },
  {
    title: MENU_NAMES_ICONS_KEYS.SERVICES,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'ACCOUNTS_BILLER_SERVICES_VIEW',
    link: '/accounts/quick-pay/servicesView',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.ACCOUNT,
        link: '/accounts',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.QUICKY_PAY,
        link: '/accounts/quick-pay',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.FORM,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'TRANSFERS_BILLER_SERVICE_FORM',
    link: '/transfers/quick-pay/services/product',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.TRANSFERS,
        link: '/transfers',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.QUICKY_PAY,
        link: '/transfers/quick-pay',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.FORM,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'ACCOUNTS_BILLER_SERVICE_FORM',
    link: '/accounts/quick-pay/services/product',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.ACCOUNT,
        link: '/accounts',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.QUICKY_PAY,
        link: '/accounts/quick-pay',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.MT103,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_DownloadCenterIcon,
    parentIcon: Dashboard_DownloadCenterIcon,
    breadCumKey: 'BENE_MT103',
    link: '/transfers/download-center/mt103',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.TRANSFERS,
        link: '/transfers',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.DOWNLOAD_CENTER,
        link: '/transfers/download-center',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.DOWNLOAD_RECEIPT,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_DownloadCenterIcon,
    parentIcon: Dashboard_DownloadCenterIcon,
    breadCumKey: 'BENE_RECIEPT',
    link: '/transfers/download-center/reciept',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.TRANSFERS,
        link: '/transfers',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.DOWNLOAD_CENTER,
        link: '/transfers/download-center',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.BANK_STATEMENT,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_DownloadCenterIcon,
    parentIcon: Dashboard_DownloadCenterIcon,
    breadCumKey: 'BENE_BI',
    link: '/transfers/download-center/bi',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.TRANSFERS,
        link: '/transfers',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.DOWNLOAD_CENTER,
        link: '/transfers/download-center',
      },
    ],
  },
  {
    title: MENU_NAMES_ICONS_KEYS.SALARY_FILE,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_DownloadCenterIcon,
    parentIcon: Dashboard_DownloadCenterIcon,
    breadCumKey: 'SALARY_STATUS_TRANSFER_DOWNLOAD',
    link: '/transfers/download-center/salary-file-status-download',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.TRANSFERS,
        link: '/transfers',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.DOWNLOAD_CENTER,
        link: '/transfers/download-center',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.VIEW_SCHEDULED_TRANSFERS,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_DownloadCenterIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'SCHEDULED_TRANSFERS',
    link: '/transfers/viewScheduled',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.TRANSFERS,
        link: '/transfers',
      }
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.MAKE_TRANSFER,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'BENE_TRANSFER',
    link: '/transfers/beneficiary-transfers',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.TRANSFERS,
        link: '/transfers',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.VIEW_BENEFICIARY,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'BENE_VIEW',
    link: '/transfers/beneficiary-view',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.TRANSFERS,
        link: '/transfers',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.INTERNAL,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'BENE_INTERNAL_MODIFY',
    link: '/transfers/edit-beneficiary/internal',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.TRANSFERS,
        link: '/transfers',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.VIEW_BENEFICIARY,
        link: '/transfers/beneficiary-view',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.DOMESTIC,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'BENE_DOMESTIC_MODIFY',
    link: '/transfers/edit-beneficiary/other',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.TRANSFERS,
        link: '/transfers',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.VIEW_BENEFICIARY,
        link: '/transfers/beneficiary-view',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.REGIONAL,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'BENE_REGIONAL_MODIFY',
    link: '/transfers/edit-beneficiary/regional',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.TRANSFERS,
        link: '/transfers',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.VIEW_BENEFICIARY,
        link: '/transfers/beneficiary-view',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.INTERNATIONAL,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'BENE_INTERNATIONAL_MODIFY',
    link: '/transfers/edit-beneficiary/international',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.TRANSFERS,
        link: '/transfers',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.VIEW_BENEFICIARY,
        link: '/transfers/beneficiary-view',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.INTERNAL,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'BENE_INTERNAL_MODIFY',
    link: '/transfers/edit-beneficiary/internal',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.TRANSFERS,
        link: '/transfers',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.VIEW_BENEFICIARY,
        link: '/transfers/beneficiary-view',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.INTERNAL,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'TRANSFER_INTERNAL',
    link: '/transfers/beneficiary-transfers/internal',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.TRANSFERS,
        link: '/transfers',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.MAKE_TRANSFER,
        link: '/transfers/beneficiary-transfers',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.DOMESTIC,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'TRANSFER_OTHER',
    link: '/transfers/beneficiary-transfers/other',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.TRANSFERS,
        link: '/transfers',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.MAKE_TRANSFER,
        link: '/transfers/beneficiary-transfers',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.REGIONAL,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'TRANSFER_REGIONAL',
    link: '/transfers/beneficiary-transfers/regional',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.TRANSFERS,
        link: '/transfers',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.MAKE_TRANSFER,
        link: '/transfers/beneficiary-transfers',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.INTERNATIONAL,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'TRANSFER_INTERNATIONAL',
    link: '/transfers/beneficiary-transfers/international',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.TRANSFERS,
        link: '/transfers',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.MAKE_TRANSFER,
        link: '/transfers/beneficiary-transfers',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.OWN,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'TRANSFER_OWN',
    link: '/transfers/beneficiary-transfers/own',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.TRANSFERS,
        link: '/beneficiary-transfers',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.MAKE_TRANSFER,
        link: '/transfers/beneficiary-transfers',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.INTERNAL,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'BENE_INTERNAL',
    link: '/transfers/add-beneficiary/internal',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.TRANSFERS,
        link: '/transfers',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.ADD_BENEFICIARY,
        link: '/transfers/add-beneficiary',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.DOMESTIC,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'BENE_DOMESTIC',
    link: '/transfers/add-beneficiary/domestic',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.TRANSFERS,
        link: '/transfers',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.ADD_BENEFICIARY,
        link: '/transfers/add-beneficiary',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.REGIONAL,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'REGIONAL_BENE',
    link: '/transfers/add-beneficiary/regional',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.TRANSFERS,
        link: '/transfers',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.ADD_BENEFICIARY,
        link: '/transfers/add-beneficiary',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.INTERNATIONAL,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'BENE_INTERNATIONAL',
    link: '/transfers/add-beneficiary/international',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.TRANSFERS,
        link: '/transfers',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.ADD_BENEFICIARY,
        link: '/transfers/add-beneficiary',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.QUICKY_PAY,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_AccountsIcon,
    parentIcon: Dashboard_AccountsIcon,
    breadCumKey: 'ACCOUNTS_QUICK_PAY',
    link: '/accounts/quick-pay',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.ACCOUNT,
        link: '/accounts',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.QUICKY_PAY,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_AccountsIcon,
    parentIcon: Dashboard_AccountsIcon,
    breadCumKey: 'TRANSFERS_QUICK_PAY',
    link: '/transfers/quick-pay',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.TRANSFERS,
        link: '/transfers',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.INSTANT_TRANSFER,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_AccountsIcon,
    parentIcon: Dashboard_AccountsIcon,
    breadCumKey: 'ACCOUNTS_INSTANT_TRANSFER',
    link: '/accounts/quick-pay/instant-transfer',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.ACCOUNT,
        link: '/accounts',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.QUICKY_PAY,
        link: '/accounts/quick-pay',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.INSTANT_TRANSFER,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_AccountsIcon,
    parentIcon: Dashboard_AccountsIcon,
    breadCumKey: 'TRANSFERS_INSTANT_TRANSFER',
    link: '/transfers/quick-pay/instant-transfer',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.TRANSFERS,
        link: '/transfers',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.QUICKY_PAY,
        link: '/transfers/quick-pay',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.SEND_TO_WALLET,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_AccountsIcon,
    parentIcon: Dashboard_AccountsIcon,
    breadCumKey: 'SEND_TO_MOBILE',
    link: '/send-to-mobile',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.ACCOUNT,
        link: '/accounts',
      },
    ],
  },
  {
    title: MENU_NAMES_ICONS_KEYS.QR_PAY,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_AccountsIcon,
    parentIcon: Dashboard_AccountsIcon,
    breadCumKey: 'QR_CODE',
    link: '/quick-pay/qr',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.ACCOUNT,
        link: '/accounts',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.QUICKY_PAY,
        link: '/quick-pay',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.REQUESTS,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_RequestIcon,
    parentIcon: Dashboard_RequestIcon,
    breadCumKey: 'REQUEST',
    link: '/requests',
    parent: [],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.CHEQUE,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_RequestIcon,
    parentIcon: Dashboard_RequestIcon,
    breadCumKey: 'REQUEST_CHEQUE',
    link: '/requests/cheque',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.REQUESTS,
        link: '/requests',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.STANDING_INSTRUCTION,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_RequestIcon,
    parentIcon: Dashboard_RequestIcon,
    breadCumKey: 'REQUESTS_SI',
    link: '/requests/standing-instruction',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.REQUESTS,
        link: '/requests',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.STANDING_INSTRUCTION,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_RequestIcon,
    parentIcon: Dashboard_RequestIcon,
    breadCumKey: 'ACCOUNTS_SI',
    link: '/accounts/standing-instruction',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.ACCOUNT,
        link: '/accounts',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.DEBIT_CARD,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_RequestIcon,
    parentIcon: Dashboard_RequestIcon,
    breadCumKey: 'DEBIT_CARD',
    link: '/requests/debit-card',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.REQUESTS,
        link: '/requests',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.CREATE_SI,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_RequestIcon,
    parentIcon: Dashboard_RequestIcon,
    breadCumKey: 'REQUESTS_SI_CREATE',
    link: '/requests/standing-instruction/create',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.REQUESTS,
        link: '/requests',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.STANDING_INSTRUCTION,
        link: '/requests/standing-instruction',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.CREATE_SI,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_RequestIcon,
    parentIcon: Dashboard_RequestIcon,
    breadCumKey: 'ACCOUNTS_SI_CREATE',
    link: '/accounts/standing-instruction/create',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.ACCOUNT,
        link: '/accounts',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.STANDING_INSTRUCTION,
        link: '/accounts/standing-instruction',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.CARD_REQUEST,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_RequestIcon,
    parentIcon: Dashboard_RequestIcon,
    breadCumKey: 'CARD_REQUEST',
    link: '/requests/debit-card/card-request',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.REQUESTS,
        link: '/requests',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.DEBIT_CARD,
        link: '/requests/debit-card',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.BLOCK_CARD,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_RequestIcon,
    parentIcon: Dashboard_RequestIcon,
    breadCumKey: 'BLOCK_CARD',
    link: '/requests/debit-card/block-card',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.REQUESTS,
        link: '/requests',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.DEBIT_CARD,
        link: '/requests/debit-card',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.CHECK_BOOK_REQUEST,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_RequestIcon,
    parentIcon: Dashboard_RequestIcon,
    breadCumKey: 'REQUEST_CHEQUE_BOOK',
    link: '/requests/cheque/cheque-book-request',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.REQUESTS,
        link: '/requests',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.CHEQUE,
        link: '/requests/cheque',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.STOP_CHEQUE,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_RequestIcon,
    parentIcon: Dashboard_RequestIcon,
    breadCumKey: 'REQUEST_STOP_CHEQUE',
    link: '/requests/cheque/stop-cheque-payment',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.REQUESTS,
        link: '/requests',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.CHEQUE,
        link: '/requests/cheque',
      },
    ],
  },
  {
    title: MENU_NAMES_ICONS_KEYS.CHEQUE_STATUS,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_RequestIcon,
    parentIcon: Dashboard_RequestIcon,
    breadCumKey: 'CHEQUE_STATUS',
    link: '/requests/cheque/cheque-status',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.REQUESTS,
        link: '/requests',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.CHEQUE,
        link: '/requests/cheque',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.LINK_ACCOUNT,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_AccountsIcon,
    parentIcon: Dashboard_AccountsIcon,
    breadCumKey: 'LINK_ACCOUNT',
    link: '/link-account',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.ACCOUNT,
        link: '/accounts',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.DELINK_ACCOUNT,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_AccountsIcon,
    parentIcon: Dashboard_AccountsIcon,
    breadCumKey: 'DE_LINK_ACCOUNT',
    link: '/deLink-account',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.ACCOUNT,
        link: '/accounts',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.SET_ACCOUNT_NAME,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_AccountsIcon,
    parentIcon: Dashboard_AccountsIcon,
    breadCumKey: 'SET_ACCOUNT_NAME',
    link: '/add-accountName',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.ACCOUNT,
        link: '/accounts',
      },
    ],
  },
  // {
  //   title: 'Standing Instruction',
  //   desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
  //   icon: Dashboard_RequestIcon,
  //   parentIcon: Dashboard_RequestIcon,
  //   breadCumKey: 'SI_ACCOUNT',
  //   link: '/accounts/standing-instruction',
  //   parent: [
  //     {
  //       title: MENU_NAMES_ICONS_KEYS.ACCOUNT,
  //       link: '/accounts',
  //     },
  //   ],
  // },

  {
    title: MENU_NAMES_ICONS_KEYS.OPEN_ACCOUNT,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_AccountsIcon,
    parentIcon: Dashboard_AccountsIcon,
    breadCumKey: 'ADD_ACCOUNT',
    link: '/add-account',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.ACCOUNT,
        link: '/accounts',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.DETAILED_STATEMENT,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_AccountsIcon,
    parentIcon: Dashboard_AccountsIcon,
    breadCumKey: 'DETAILED_STATEMENT',
    link: '/detailed-statement',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.ACCOUNT,
        link: '/accounts',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.STATEMENT,
        link: '/statement',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.LOANS,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_AccountsIcon,
    parentIcon: Dashboard_AccountsIcon,
    breadCumKey: 'LOANS_VIEW',
    link: '/loans-view',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.ACCOUNT,
        link: '/accounts',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.DEPOSIT,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_AccountsIcon,
    parentIcon: Dashboard_AccountsIcon,
    breadCumKey: 'DEPOSIT_VIEW',
    link: '/deposit-view',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.ACCOUNT,
        link: '/accounts',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.VIEW_STATEMENT,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_AccountsIcon,
    parentIcon: Dashboard_AccountsIcon,
    breadCumKey: 'LOANS_VIEW_STATEMENT',
    link: '/loan-statement',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.ACCOUNT,
        link: '/accounts',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.LOANS,
        link: '/loans-view',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.APPROVALS,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'APPROVALS',
    link: '/approvals',
    parent: [],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.PAYMENT,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'APPROVAL_PAYMENTS',
    link: '/approvals/payments',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.APPROVALS,
        link: '/approvals',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.STOP_CHEQUE,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'APPROVAL_SC',
    link: '/approvals/stopCheque',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.APPROVALS,
        link: '/approvals',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.STANDING_INSTRUCTION,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'APPROVAL_SI',
    link: '/approvals/si',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.APPROVALS,
        link: '/approvals',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.STANDING_INSTRUCTION,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'APPROVAL_SI',
    link: '/approvals/si',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.APPROVALS,
        link: '/approvals',
      },
    ],
  },

  {
    title: ACCOUNTS_MENU_KEYS.CARD_LESS_CASH,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'APPROVAL_CARD_LESS_CASH',
    link: '/approvals/cardLessCash',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.APPROVALS,
        link: '/approvals',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.CHEQUE_BOOK,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'APPROVAL_CHEQUE_BOOK',
    link: '/approvals/chequeBook',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.APPROVALS,
        link: '/approvals',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.FUND_TRANSFER,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'APPROVAL_FT',
    link: '/approvals/ft',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.APPROVALS,
        link: '/approvals',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.SALARY_UPLOAD,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'APPROVAL_SALARY',
    link: '/approvals/salaryUpload',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.APPROVALS,
        link: '/approvals',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.BENEFICIARY,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'APPROVAL_BENEFICIARIES',
    link: '/approvals/beneficiaries',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.APPROVALS,
        link: '/approvals',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.DEPOSIT,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'APPROVAL_TD',
    link: '/approvals/td',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.APPROVALS,
        link: '/approvals',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.HISTORY,
    desc: MENU_NAMES_ICONS_KEYS.HISTORY_DESC,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'HISTORY',
    link: '/history',
    parent: [],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.PAYMENT,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'HISTORY_PAYMENTS',
    link: '/history/payments',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.HISTORY,
        link: '/history',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.STOP_CHEQUE,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'HISTORY_SC',
    link: '/history/stopCheque',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.HISTORY,
        link: '/history',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.STANDING_INSTRUCTION,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'HISTORY_SI',
    link: '/history/si',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.HISTORY,
        link: '/history',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.STANDING_INSTRUCTION,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'HISTORY_SI',
    link: '/history/si',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.HISTORY,
        link: '/history',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.CARD_LESS_CASH,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'HISTORY_CARD_LESS_CASH',
    link: '/history/cardLessCash',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.HISTORY,
        link: '/history',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.CHEQUE_BOOK,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'HISTORY_CHEQUE_BOOK',
    link: '/history/chequeBook',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.HISTORY,
        link: '/history',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.FUND_TRANSFER,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'HISTORY_FT',
    link: '/history/ft',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.HISTORY,
        link: '/history',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.SALARY_UPLOAD,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'HISTORY_SALARY',
    link: '/history/salaryUpload',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.HISTORY,
        link: '/history',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.BENEFICIARY,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'HISTORY_BENEFICIARIES',
    link: '/history/beneficiaries',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.HISTORY,
        link: '/history',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.DEBIT_CARD,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'HISTORY_DEBIT_CARD',
    link: '/history/debitCard',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.HISTORY,
        link: '/history',
      },
    ],
  },
  {
    title: MENU_NAMES_ICONS_KEYS.BLOCK_CARD,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'HISTORY_BLOCK_CARD',
    link: '/history/blockCard',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.HISTORY,
        link: '/history',
      },
    ],
  },
  {
    title: MENU_NAMES_ICONS_KEYS.DEPOSIT,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'HISTORY_TD',
    link: '/history/td',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.HISTORY,
        link: '/history',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.CURRENT_MONTH,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_AccountsIcon,
    parentIcon: Dashboard_AccountsIcon,
    breadCumKey: 'CURRENT_MONTH',
    link: '/currentMonth',
    parent: [
      {
        title:MENU_NAMES_ICONS_KEYS.ACCOUNT,
        link: '/accounts',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.STATEMENT,
        link: '/statement',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.DETAILED_STATEMENT,
        link: '/detailed-statement',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.LAST_TWO_MONTHS,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_AccountsIcon,
    parentIcon: Dashboard_AccountsIcon,
    breadCumKey: 'LAST_TWO_MONTH',
    link: '/currentMonth',
    parent: [
      {
        title:MENU_NAMES_ICONS_KEYS.ACCOUNT,
        link: '/accounts',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.STATEMENT,
        link: '/statement',
      },
      {
        title:  MENU_NAMES_ICONS_KEYS.DETAILED_STATEMENT,
        link: '/detailed-statement',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.LAST_THREE_MONTHS,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_AccountsIcon,
    parentIcon: Dashboard_AccountsIcon,
    breadCumKey: 'LAST_THREE_MONTH',
    link: '/currentMonth',
    parent: [
      {
        title:MENU_NAMES_ICONS_KEYS.ACCOUNT,
        link: '/accounts',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.STATEMENT,
        link: '/statement',
      },
      {
        title:  MENU_NAMES_ICONS_KEYS.DETAILED_STATEMENT,
        link: '/detailed-statement',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.CUSTOM_RANGE,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_AccountsIcon,
    parentIcon: Dashboard_AccountsIcon,
    breadCumKey: 'CUSTOM_DATES',
    link: '/currentMonth',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.ACCOUNT,
        link: '/accounts',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.STATEMENT,
        link: '/statement',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.DETAILED_STATEMENT,
        link: '/detailed-statement',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.CARD_LESS_CASH,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'CARD_LESS_CASH',
    link: '/cardLessCash',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.TRANSFERS,
        link: '/transfers',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.GENERATE_TOKEN,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_TransfersIcon,
    parentIcon: Dashboard_TransfersIcon,
    breadCumKey: 'CARD_LESS_CASH_GENERATE_TOKEN',
    link: '/cardLessCash/generateToken',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.TRANSFERS,
        link: '/transfers',
      },
      {
        title: MENU_NAMES_ICONS_KEYS.CARD_LESS_CASH,
        link: '/cardLessCash',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.DEBIT_CARD,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'APPROVAL_DEBIT_CARD',
    link: '/approvals/debitCard',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.APPROVALS,
        link: '/approvals',
      },
    ],
  },

  {
    title: MENU_NAMES_ICONS_KEYS.BLOCK_CARD,
    desc: MENU_NAMES_ICONS_KEYS.DESCRIPTION_HERE,
    icon: Dashboard_PaymentsIcon,
    parentIcon: Dashboard_PaymentsIcon,
    breadCumKey: 'APPROVAL_BLOCK_CARD',
    link: '/approvals/blockCard',
    parent: [
      {
        title: MENU_NAMES_ICONS_KEYS.APPROVALS,
        link: '/approvals',
      },
    ],
  },

  // {
  //   title: MENU_KEYS.LASTTWOMONTH,
  //   desc: MENU_KEYS.DESCRIPTION_HERE,
  //   icon: Dashboard_AccountsIcon,
  //   parentIcon: Dashboard_AccountsIcon,
  //   breadCumKey: 'LAST_TWO_MONTH',
  //   link: '/lastTwoMonth',
  //   parent: [
  //     {
  //       title: MENU_KEYS.ACCOUNTS,
  //       link: '/accounts',
  //     },
  //     {
  //       title: MENU_KEYS.STATEMENT,
  //       link: '/statement',
  //     },
  //     {
  //       title: MENU_KEYS.DETAILED_STATEMENT,
  //       link: '/detailed-statement',
  //     },
  //   ],
  // },
  // {
  //   title: MENU_KEYS.LASTTHREEMONTH,
  //   desc: MENU_KEYS.DESCRIPTION_HERE,
  //   icon: Dashboard_AccountsIcon,
  //   parentIcon: Dashboard_AccountsIcon,
  //   breadCumKey: 'LAST_THREE_MONTH',
  //   link: '/lastThreeMonth',
  //   parent: [
  //     {
  //       title: MENU_KEYS.ACCOUNTS,
  //       link: '/accounts',
  //     },
  //     {
  //       title: MENU_KEYS.STATEMENT,
  //       link: '/statement',
  //     },
  //     {
  //       title: MENU_KEYS.DETAILED_STATEMENT,
  //       link: '/detailed-statement',
  //     },
  //   ],
  // },
  // {
  //   title: MENU_KEYS.CUSTOMDATES,
  //   desc: MENU_KEYS.DESCRIPTION_HERE,
  //   icon: Dashboard_AccountsIcon,
  //   parentIcon: Dashboard_AccountsIcon,
  //   breadCumKey: 'CUSTOM_DATES',
  //   link: '/customDates',
  //   parent: [
  //     {
  //       title: MENU_KEYS.ACCOUNTS,
  //       link: '/accounts',
  //     },
  //     {
  //       title: MENU_KEYS.STATEMENT,
  //       link: '/statement',
  //     },
  //     {
  //       title: MENU_KEYS.DETAILED_STATEMENT,
  //       link: '/detailed-statement',
  //     },
  //   ],
  // },
]
